export interface IMinMaxPrice {
    minPrice?: number;
    maxPrice?: number;
}
